import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tyt-pricing-prompt-offers',
  templateUrl: './pricing-prompt-offers.component.html',
  styleUrls: ['./pricing-prompt-offers.component.scss']
})
export class PricingPromptOffersComponent implements OnInit {
  
  @Input()
  headLine : string;

  @Input()
  caption : string;

  constructor() { }

  ngOnInit() {
  }

}
